import { Inertia } from '@inertiajs/inertia'
import { Component, getAssetPath, h } from '@stencil/core'
import { Fragment, Host, JsonDocs, JsonDocsComponent, Listen, State, Watch } from '@stencil/core/internal'
import Fuse from 'fuse.js'
import { groupBy } from 'lodash-es'

Inertia.on('invalid', (event) => {
  event.preventDefault()
  return false
})

@Component({
  tag: 'preview-app',
})
export class Preview {
  @State() docsSrc: string
  @State() selected: JsonDocsComponent
  @State() query = ''
  @State() showNav = false

  pollInterval: number

  get components(): JsonDocsComponent[] {
    const docs: JsonDocs = JSON.parse(this.docsSrc)
    const all = docs.components.filter((cp) => {
      return cp.tag.endsWith('-demo')
    })
    const fuse = new Fuse(all, { keys: ['tag'] })
    return this.query ? fuse.search(this.query).map((f) => f.item) : all
  }

  get selectedDocs() {
    if (this.selected && this.selected.docsTags) {
      const readme = this.selected.docsTags.find((obj) => obj.name === 'readme')
      return readme && readme.text
    }
  }

  loadDocs = async () => {
    try {
      this.docsSrc = await fetch(getAssetPath('../docs.json')).then((r) => r.text())
    } catch {
      clearInterval(this.pollInterval)
    }
  }

  async componentWillLoad() {
    await this.loadDocs()
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
    }
    // I don't understand the point of this but find it very annoying
    // this.pollInterval = setInterval(this.loadDocs, 1000) as any
    // eslint-disable-next-line
    window.fathomLogger = console
  }

  @Listen('popstate', { target: 'window' })
  onPopState() {
    this.parseDocs()
  }

  @Watch('docsSrc')
  parseDocs() {
    const index = location.pathname.lastIndexOf('/') + 1
    const path = location.pathname.slice(index)
    this.selected = this.components.find((c) => c.tag === path)
  }

  @Listen('click')
  onClick() {
    this.showNav = false
  }

  render() {
    const groupedComponents = groupBy(this.components, (arg) => arg.tag.slice(0, arg.tag.indexOf('-')))
    return (
      <Host class='flex text-glyph-base bg-surface-base'>
        <main class='flex overflow-auto flex-col w-screen h-screen'>
          {this.selected && <this.selected.tag class='m-auto' />}
        </main>
        <nav class='flex fixed top-0 bottom-0 left-0 z-menu flex-col p-3 m-2 pointer-events-none'>
          {this.showNav ? (
            <Fragment>
              <menu class='flex overflow-hidden flex-col p-0 m-0 h-full bg-surface-high rounded-md pointer-events-auto'>
                <ui-input
                  size='sm'
                  autofocus
                  icon='search'
                  class='flex-shrink-0 m-2 shadow-inner'
                  onInput={(e) => (this.query = (e.target as HTMLInputElement).value)}
                  onClick={(e) => {
                    e.stopImmediatePropagation()
                  }}
                ></ui-input>

                <ui-scrollarea class='flex-grow my-1 rounded-none'>
                  <div class='flex flex-col'>
                    {Object.entries(groupedComponents).map(([group, components]) => [
                      <h1 class='py-2 px-4 font-bold'>{group}</h1>,
                      components.map((c) => (
                        <a
                          href=''
                          onClick={(e) => {
                            e.preventDefault()
                            this.goto(c)
                          }}
                          class={{
                            'text-glyph-lighter hover:text-glyph-base': this.selected !== c,
                            'bg-brand': this.selected === c,
                            'transition duration-200 pb-1 pr-4 pl-5': true,
                          }}
                        >
                          {c.tag.replace('-demo', '').replace(group + '-', '')}
                        </a>
                      )),
                    ])}
                  </div>
                </ui-scrollarea>
              </menu>
            </Fragment>
          ) : (
            <ui-icon
              icon='three-dots'
              class='p-3 bg-surface-high rounded-md pointer-events-auto'
              onClick={(e) => {
                e.stopImmediatePropagation()
                this.showNav = true
              }}
            />
          )}
        </nav>
      </Host>
    )
  }
  goto(c: JsonDocsComponent) {
    this.selected = c
    const index = location.pathname.lastIndexOf('/') + 1
    history.pushState(null, c.tag, location.pathname.slice(0, index) + c.tag)
  }
}
